import { render, staticRenderFns } from "./AncillaryTable.vue?vue&type=template&id=566946e4"
import script from "./AncillaryTable.vue?vue&type=script&lang=js"
export * from "./AncillaryTable.vue?vue&type=script&lang=js"
import style0 from "./AncillaryTable.vue?vue&type=style&index=0&id=566946e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports